import React from 'react';
var useCallback = React.useCallback,
    useEffect = React.useEffect,
    useState = React.useState,
    useRef = React.useRef;
export var useDebounceCallback = function useDebounceCallback(callback) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var leading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var timeout = useRef(void 0);
  var deps = [callback, wait, leading]; // Cleans up pending timeouts when the deps change

  function _ref() {
    clearTimeout(timeout.current);
    timeout.current = void 0;
  }

  useEffect(function () {
    return _ref;
  }, deps);

  function _ref2() {
    timeout.current = void 0;
  }

  return useCallback(function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var self = this; // eslint-disable-next-line prefer-rest-params

    var args = arguments;
    var current = timeout.current; // Calls on leading edge

    if (current === void 0 && leading) {
      timeout.current = setTimeout(_ref2, wait);
      return callback.apply(self, args);
    } // Clear the timeout every call and start waiting again


    clearTimeout(current); // Waits for `wait` before invoking the callback

    timeout.current = setTimeout(function () {
      timeout.current = void 0;
      callback.apply(self, args);
    }, wait);
  }, deps);
};
export var useDebounce = function useDebounce(initialState, wait, leading) {
  var _ref_0 = useState(initialState);

  var setState = _ref_0[1];
  var state = _ref_0[0];
  return [state, useDebounceCallback(setState, wait, leading)];
};
export default useDebounce;